import { render, staticRenderFns } from "./FormInputPowerOldNewSum.vue?vue&type=template&id=b6ce2b54&"
import script from "./FormInputPowerOldNewSum.vue?vue&type=script&lang=ts&"
export * from "./FormInputPowerOldNewSum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports